const rootActionPath = 'core/RecentStores';

export const RECENT_STORES_FROM_SEARCHBAR_VIEW = `${rootActionPath}/fromSearchBar/VIEW`;
